module.exports = "<header>\n  <sa-activate-guide-account ng-if=\"ctrl.showActivation\" done=\"ctrl.done()\"></sa-activate-guide-account>\n<!--  <sa-terms-change ng-if=\"ctrl.showPolicyChange\" done=\"ctrl.doneTerms()\"></sa-terms-change>-->\n  <sa-navigation></sa-navigation>\n</header>\n";


//////////////////
// WEBPACK FOOTER
// ./app/src/directives/header.html
// module id = 473
// module chunks = 24